<div class="w-100 float-left text-13x">

    <div class="w-100 float-left v-align relative" (click)="clicked()">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0"> {{'notificationEditor' | translate}} </h5>
        </div>
    </div>
    <div class="w-100 float-left p-3 light-bg mt-3">
        <h6 class="medium mb-0"> {{'filters' | translate }} </h6>
        <div class="form-group mt-2 w-75 d-inline-flex relative">
            <div class="relative w-75">
                <input type="text" class="form-control" [(ngModel)]="notificationFilter.name"
                       (keyup.enter)="searchAndFetchNotificationByFilterData()">
                <!-- isCollapsed = !isCollapsed -->
                <i class="fa fa-caret-down tr-0" (click)="toggleSearch()" [attr.aria-expanded]="!showSearchFilter"
                   aria-controls="collapseExample"></i>
            </div>
            <button class="btn btn-primary" (click)="searchAndFetchNotificationByFilterData()"> {{'search'|translate}}
            </button>
            <div class="w-75 absolute top-100 left-0 p-3 white-bg z-i shadow" id="collapseExample"
                 [ngbCollapse]="!showSearchFilter">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium"> {{'name'|translate}} </label>
                            <input type="text" class="form-control" placeholder="{{'name'|translate}} "
                                   [(ngModel)]="notificationFilter.name"
                                   (keyup.enter)="searchAndFetchNotificationByFilterData();toggleSearch()">
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium"> {{'description'|translate}} </label>
                            <input type="text" class="form-control" placeholder=" {{'description'|translate}}"
                                   [(ngModel)]="notificationFilter.description"
                                   (keyup.enter)="searchAndFetchNotificationByFilterData();toggleSearch()">
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-6 col-12">
                        <div class="form-group w-100" (click)="searchStrategy('')">
                            <label class="medium"> {{'notification'|translate}} {{'types'|translate}} </label>
                            <angular2-multiselect [data]="notificationTypesTranslated"
                                                  [(ngModel)]="selectedNotificationTypeItems"
                                                  [settings]="notificationTypesSettings">
                                <c-search>
                                    <ng-template>
                                        <input type="text" (keyup)="searchStrategy($event.target.value)"
                                               placeholder="{{'search' | translate}}"
                                               style="border: none;width: 100%; height: 100%;outline: none;"/>
                                    </ng-template>
                                </c-search>
                                <c-item>
                                    <ng-template let-item="item">
                                        <label style="color: #333;">{{item.value}}</label>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-6 col-12">
                        <div class="form-group w-100" (click)="searchStrategy('')">
                            <label class="medium"> {{'notificationChannels' | translate}} </label>
                            <angular2-multiselect [data]="notificationChannelsFiltered"
                                                  [(ngModel)]="selectedNotificationChannels"
                                                  [settings]="notificationTypesSettings">
                                <c-search>
                                    <ng-template>
                                        <input type="text" (keyup)="searchStrategyChannel($event.target.value)"
                                               placeholder="{{'search' | translate}}"
                                               style="border: none;width: 100%; height: 100%;outline: none;"/>
                                    </ng-template>
                                </c-search>
                                <c-item>
                                    <ng-template let-item="item">
                                        <label style="color: #333;">{{item.value}}</label>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-6 col-12">
                        <!-- <input name=""> -->
                        <label class="medium"> {{'notification'|translate}} {{'groups'|translate}}</label>
                        <select class="form-control w-100" [(ngModel)]="selectedNotificationGroup"
                                name="selectedNotificationGroup">

                            <option value="null" disabled selected>{{'select' | translate}} {{'notification'|translate}}
                                {{'groups'|translate}}
                            </option>
                            <option *ngFor="let groupKey of allNotificationGroups" [value]="groupKey">{{groupKey |
                                translate}}
                            </option>
                        </select>
                    </div>


                    <div class="col-12 mt ">
                        <button class="btn btn-link float-left" (click)="reset()"> {{'resetKey' | translate}}</button>
                        <button class="btn btn-primary float-right ml-3"
                                (click)="searchAndFetchNotificationByFilterData();toggleSearch()">{{'apply'
                            | translate}}
                        </button>
                        <!-- isCollapsed = !isCollapsed -->
                        <button class="btn btn-light float-right" (click)="toggleSearch()"
                                [attr.aria-expanded]="!showSearchFilter"
                                aria-controls="collapseExample">{{'close' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <!-- DESIGNATION DETAILS GRID -->
    <div class="w-100 float-left mt-3">
        <div class="light-bg w-100 float-left p-2 grid-details" (click)="clicked()">
            <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'notificationId' | translate}} </h6>
            </div>
            <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
            </div>
            <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'description' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'notificationChannel' | translate}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'disabled' | translate}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                <h6 class="mb-lg-0 medium"> {{'action' | translate}} </h6>
            </div>
        </div>
        <ng-container *ngIf="notifications && notifications.content.length > 0">
            <div class="w-100 float-left p-md-2 grid-details"
                 *ngFor="let notification of notifications.content ; let i=index">

                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{notification.notificationId}} </h6>
                </div>
                <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{notification.name}} </h6>
                </div>
                <div class="col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{notification.description}} </h6>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{notification.notificationChannel}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{notification.isDisabled}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                    <h6 class="mb-lg-0" (click)="tableActions(i)" ngbTooltip="Click for more options">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editNotification(notification)">
                                <i class="fa fa-pencil mr-2"></i> {{'edit' | translate}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="notifications && notifications.content.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                    <img src="./assets/img/load.gif" alt="loading" width="80px">
                </div> -->
                <div class="loader-div">
                    <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>

        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()">
            <h6 class="float-left mb-0"> {{((notificationFilter.page-1)*notificationFilter.pageSize)+1}} -
                {{notificationFilter.pageSize*(notificationFilter.page-1)+notifications.numberOfElements}}
                {{'itemsOf' | translate}} {{notifications.totalElements}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" name="pageSize"
                        [(ngModel)]="notificationFilter.pageSize"
                        (change)="onPageSizeChanged()">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="notifications.totalElements" [rotate]="true" [maxSize]="5"
                            [pageSize]="notificationFilter.pageSize"
                            [ellipses]="false" [(page)]="notificationFilter.page" [boundaryLinks]="true"
                            (pageChange)="onPageChange()"
                            class="float-right"></ngb-pagination>

            <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
                 style="margin-right:1px; margin-left:10px;cursor: pointer;"><i
                    class="fa fa-refresh" aria-hidden="true"></i></div>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/notificationGridComponent.html